<template>
    <q-card>
        <q-card-section>
            <div class="text-h6">移庫</div>
            <q-badge color="blue" class="q-mb-lg">
                如果有輸入「新庫位名稱」將視為轉移到新庫位
            </q-badge>
        </q-card-section>

        <q-card-section>
            <div class="row q-mb-sm" >
                <div class="col">所選庫位名稱： {{ productSelectStock.Title }}</div>
                <div class="col">所選庫位數量： {{ productSelectStock.Stock }}</div>
            </div>
            <div class="row q-gutter-sm">
                <div class="col">
                    <q-select 
                    filled 
                    v-model="move.blockID" 
                    :options="stockList"
                    option-value="ID" 
                    option-label="Title" 
                    emit-value 
                    map-options 
                    label="轉移庫存到" 
                    />
                </div>
                <div class="col">
                    <q-input v-model="move.stock" label="轉移數量" />
                </div>
            </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
            <div class="text-h6">轉移到新庫位</div>
            <div class="row q-gutter-sm">
                <div class="col">
                    <q-input v-model="move.title" label="新庫位名稱" />
                </div>
                <div class="col">
                    <q-input v-model="move.stock" label="轉移數量" />
                </div>
            </div>
            <div class="text-h6 q-mt-xs">已存在的庫位名稱</div>
            <div class="row">
                <div class="col">
                    <q-btn v-for="(row, index) in titleList" :key="index" color="primary" text-color="white" icon="add" @click="handleStockTitleClick(row.Title)" class="q-ml-xs">
                        {{ row.Title }}
                    </q-btn>
                </div>
            </div>
        </q-card-section>
        <q-card-actions align="right" class="bg-white text-teal">
            <q-btn color="green" label="送出" @click="productPutStockMove(move)" />
            <q-btn color="blue" label="關閉" v-close-popup />
        </q-card-actions>
    </q-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: "StockMove",
    data() {
      return {
          titleList: [],
          move: {
              fromBlockID: "",
              blockID: "",
              stock: "",
              title: ""
          },
          stockList: []
      }
    },
    created() {
        this.move.fromBlockID = this.productSelectStock.ID
        if (this.productDetail.StockBlock) {
            this.productDetail.StockBlock.map(r => {
                let find = this.stockList.find(f => f.ID === r.ID)

                if (!find && this.productSelectStock.ID !== r.ID) {
                    this.stockList.push(r)
                }
            })
        }
        this.$store.dispatch('productGetStockWithOutSelect', this.productSelectStock.Title).then(res => {
            this.titleList = res
        })
    },
    computed: {
      ...mapGetters(['productSelectStock', 'productDetail'])
    },
    methods: {
        handleStockTitleClick(title) {
            this.move.title = title
            // this.titleList.splice(index, 1)
        },
        ...mapActions(['productPutStockMove'])
    }
  }
</script>